import { Navigate, Route, Routes } from 'react-router-dom';
import { DescriptionPage } from './description';
import { ShopMain } from './main';
import { ManualModal } from './manual-modal';
import { Order } from './order';
import { Orders } from './orders';
import { Product } from './product';
import { Products } from './products';
import { PromoModal } from './promo-modal';
import { SearchPage } from './search';
import { SpecificationPage } from './specification';
import { VideoPage } from './video';

export const Shop: React.FC = () => {
  return (
    <Routes>
      <Route path=":code" element={<ShopMain />}>
        <Route index element={<Navigate to={'products'} />} />
        <Route path=":tab">
          <Route path="promo" element={<PromoModal />} />
          <Route path="manual" element={<ManualModal />} />
        </Route>
        <Route path="products">
          <Route index element={<Products />} />
          <Route path="product/:id" element={<Product />} />

          <Route path="product/:id/description" element={<DescriptionPage />} />
          <Route path="product/:id/specification" element={<SpecificationPage />} />
          <Route path="product/:id/video" element={<VideoPage />} />
          <Route path="search" element={<SearchPage />} />
        </Route>
        <Route path="orders">
          <Route index element={<Orders />} />
          <Route path="order/:id" element={<Order />} />
          {/* <Route path="search" element={<SearchPage />} /> */}
        </Route>
      </Route>
    </Routes>
  );
};
